<template>
    <div id="app">
        <router-view />
    </div>
</template>
<script>
import { mapActions } from "vuex";
import { sync as syncPush, requestResync as requestPushResync, TOKEN_KEY as PUSH_TOKEN_KEY, RESYNC_DELAY as PUSH_RESYNC_DELAY } from "@/plugins/push";
export default {
    data(){
        return {
            timer: null,
            latest: Date.now(),
        }
    },
    created(){
        this.init();
    },
    mounted() {
        if (this.accessToken) this.getUser();
        if (this.accessToken) this.syncPush();
        window.addEventListener("storage", this.onStorage);
    },
    beforeDestroy() {
        window.removeEventListener("storage", this.onStorage);
    },
    methods: {
        ...mapActions(['getUser']),
        ...mapActions('ui', ['getLogo']),
        init(){
            document.addEventListener("mousemove", () => { this.reset() }, false);
            document.addEventListener("mousedown", () => { this.reset() }, false);
            document.addEventListener("keypress", () => { this.reset() }, false);
            document.addEventListener("touchmove", () => { this.reset() }, false);
            document.addEventListener("onscroll", () => { this.reset() }, false);
            
            this.getLogo();
            this.onTimer();
            this.loadChannelTalk();
            this.setRefid();
        },
        reset(){
            this.latest = Date.now();
        },
        onTimer(){
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                if(this.refreshToken){
                    if(60 * 60 * 1000 < (Date.now() - this.latest) || this.payload.exp * 1000 <= Date.now()){
                        this.$store.dispatch("logout");
                    }
                }
                this.onTimer();
            }, 1000);
        },
        loadChannelTalk() {
            (function(){var w=window;if(w.ChannelIO){return w.console.error("ChannelIO script included twice.");}var ch=function(){ch.c(arguments);};ch.q=[];ch.c=function(args){ch.q.push(args);};w.ChannelIO=ch;function l(){if(w.ChannelIOInitialized){return;}w.ChannelIOInitialized=true;var s=document.createElement("script");s.type="text/javascript";s.async=true;s.src="https://cdn.channel.io/plugin/ch-plugin-web.js";var x=document.getElementsByTagName("script")[0];if(x.parentNode){x.parentNode.insertBefore(s,x);}}if(document.readyState==="complete"){l();}else{w.addEventListener("DOMContentLoaded",l);w.addEventListener("load",l);}})();
      
            this.updateChannelTalk();
        },
        updateChannelTalk(){
            ChannelIO('boot', this.channelTalkOption);
        },
        // 알림을 이미 허용한 브라우저면 로그인한 회원으로 토큰을 다시 등록한다(탭당 1회). 실패는 sync 가 console 에만 남긴다
        syncPush() {
            syncPush();
        },
        // 다른 탭의 로그아웃이 브라우저 공통 푸시 토큰을 지웠으면, 아직 로그인된 이 탭이 다시 등록한다.
        // 이 탭의 등록이 진행 중이면 그 등록은 표시를 찍지 않고 끝난 뒤 한 번 더 등록한다(해제가 등록보다 늦게 처리됐을 수 있다)
        onStorage(event) {
            if (event.key != PUSH_TOKEN_KEY && event.key != null) return;
            if (event.newValue || !this.accessToken) return;
            requestPushResync();
            // 로그아웃한 탭의 해제 요청이 서버에 먼저 닿도록 잠시 뒤에 다시 등록한다
            setTimeout(() => this.syncPush(), PUSH_RESYNC_DELAY);
        },
        setRefid() {
            console.log({refid:this.refid})
            if (!this.refid) return;
            this.$cookies.set("refid", this.refid);
        },
    },
    computed: {
        refreshToken(){
            return this.$store.state.refreshToken;
        },
        accessToken(){
            return this.$store.state.accessToken;
        },
        payload(){
            return JSON.parse(atob(this.refreshToken?.split('.')[1] || '') || "{}");
        },
        user() {
            return this.$store.state.user;
        },
        channelTalkOption() {
            let options = { pluginKey: "751e736b-4e7a-455c-8394-953e99dfbb01" };

            if(this.accessToken) {
                options.memberId= this.user?._id;
                options.profile= {
                    name: this.user?.name,
                    username: this.user?.username,
                    mobileNumber: "82"+this.user?.phone.replace(/-/g, '').slice(1),
                    mail: this.user?.email
                }
            }
            return options;
        },
        removeChannelTalkCookie() {
            const hostname = window.location.hostname;
            let domain = "";

            switch (true) {
                case hostname.includes("localhost"):
                    domain = "";
                    break;
                case hostname.includes("uxi.kr"):
                    domain = ".uxi.kr";
                    break;
                case hostname.includes(".daehanbooks.co.kr"):
                    domain = ".daehanbooks.co.kr";
                    break;
                case hostname.includes("salerbook.net"):
                    domain = ".salerbook.net";
                    break;
                case hostname.includes("salerbook.com"):
                    domain = ".salerbook.com";
                    break;
            }

            this.$cookies.remove("ch-session-180654", "/", domain);
        },
        refid() {
            return this.$route.query.refid;
        },
    },
    watch: {
        accessToken(){
            if(this.accessToken) this.syncPush();
            if(!this.accessToken){
                //채널톡 제거
                this.removeChannelTalkCookie();
                // document.cookie= "ch-session-180654"+ '=; Max-Age=0; path=/; domain=.uxi.kr';
                this.updateChannelTalk();

                alert("로그아웃 되었습니다");
                this.$router.push("/");
            }
        },
        "user._id"(){
            this.updateChannelTalk();
        },
        "$route.path"() {
            this.getLogo();
        },
        refid() {
            this.setRefid();
        },
    }        
}
</script>